module.exports = __webpack_public_path__ + "subscription-5-54ef37f64ce3d65ce4a8.png";